import { Component, EventEmitter, Output } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-sort-by-modal',
    templateUrl: 'sort-by-modal.component.html',
    styleUrls: ['sort-by-modal.component.scss'],
    imports: [NgIf, NgFor],
})
export class SortByModalComponent {
  @Output()
  public readonly emitSelectedSort = new EventEmitter<ISortByOptions>();

  public showModal: boolean = false;

  public selectedSortCategory: ISortByOptions = <ISortByOptions>'';

  public sortOptions = [
    { label: 'Sort in alphabetical order', type: 'alphabetical' },
    { label: 'Sort by publish date', type: 'publish-date' },
  ] as ISortOptions[];

  /**
   * set and emit the selected sort option
   * @param category
   */
  public sortBy(category: ISortByOptions) {
    this.selectedSortCategory = category;
    this.emitSelectedSort.emit(category);
  }

  public open(): void {
    this.showModal = true;
  }

  public close(): void {
    this.showModal = false;
  }
}

export interface ISortOptions {
  label: string;
  type: ISortByOptions;
}

export type ISortByOptions =
  | 'alphabetical'
  | 'type'
  | 'publish-date'
  | 'rating';
